// removed by extract-text-webpack-plugin
module.exports = {"container":"Settings__container___1nGlR","centerDiv":"Settings__centerDiv___36DfS","holder":"Settings__holder___1oXUI","joinUsContainer":"Settings__joinUsContainer___1SKCC","joinUsBanner":"Settings__joinUsBanner___1_6Cf","joinUsDetails":"Settings__joinUsDetails___YV8a_","removePadding":"Settings__removePadding___1uQIK"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Settings/Settings.scss
// module id = 1586
// module chunks = 0